<template>
  <div id="literature-content" :class="{ 'no-items': !ids.length, 'loading': !loaded }">

    <div class="SelectItems" id="start" v-show="!viewFinalized">

<!--      <literature-cart-->
<!--        v-if="showCartIcon"-->
<!--        :next-handler="placeRequest"-->
<!--        :remove-item-handler="removeItemFromCart"-->
<!--        :cart="itemsInCart"-->
<!--      />-->

      <div class="literature-items" v-if="ids.length > 0">

        <div v-for="id in ids"
             :key="id"
             :class="{'literature-item': true, added: cart.ids.indexOf(id) !== -1, focused: id === focusedAt, animated: (id === focusedAt) && animated }"
        >
          <div class="literature-title">
            <span>
              {{ items[id].title }}
            </span>
          </div>

          <div v-if="!!items[id].image.url" :class="{'literature-image': true, shadow: items[id].image.shadow }">
            <img :src="items[id].image.url" :alt="items[id].image.meta.alt" />
          </div>

          <div class="literature-downloads">
            <a v-for="download in items[id].downloads" class="btn download-item" :href="download.url" download>
              <span class="text">{{ getExtension(download.name) }}</span>
              <svg aria-hidden="true" class="fa-arrow-down arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"/></svg>
            </a>
          </div>

          <hr v-show="items[id].inventory && items[id].inventory.length > 0" />

          <div class="card-actions-wrapper" v-if="!!items[id].inventory && items[id].inventory.length">
            <div class="action-label">
              Physical Request
            </div>

            <div class="actions">
              <div class="left">
                <label :for="`qty-${id}`" style="display: none;">Choose QTY</label>
                <select
                  v-model="cart.quantity[id]"
                  :class="{ 'empty': !cart.quantity[id] }"
                  :id="`qty-${id}`"
                >
                  <option disabled selected value="">Choose QTY</option>
                  <option
                    v-for="quantity in items[id].inventory"
                    :value="quantity"
                  >
                    {{ quantity }}
                  </option>
                </select>

              </div>
              <div class="right">
                <button class="btn primary" type="button" @click="toggleItemFromCart(id)" :disabled="!cart.quantity[id]">
                  {{ cart.ids.includes(id) ? 'Remove' : 'Add' }}
                </button>
              </div>
            </div>

          </div>

        </div>

      </div>

      <div class="finalize-request-button">
        <a v-if="!!cart.ids.length && !viewFinalized"
           href="#stage"
           class="place-request btn secondary"
           @click="placeRequest"
        >
          Place Request
        </a>
      </div>

    </div>

    <!-- /////////////////// -->
    <!-- YOUR SELECTED ITEMS -->
    <!-- /////////////////// -->

    <transition name="fade">

      <div class="Checkout" v-show="viewFinalized">

        <div class="selected-items">
          <div class="left">
            <div class="form-title">
              Your Selected Items
            </div>
          </div>
          <div class="right">

            <div class="cart-item-wrapper">
              <div v-for="item in itemsInCart" class="cart-item">
                <div class="item-title">{{ item.title }}</div>
                <div class="item-quantity"><span>Qty: </span>{{ item.quantity }}</div>
              </div>
            </div>

            <div class="request-divider"></div>

            <div class="edit-request-wrapper">
              <a href="#stage" class="edit-request btn secondary"
                 v-if="viewFinalized"
                 @click.prevent="toSelection"
              >
                Edit Selection
              </a>
            </div>

          </div>

        </div>


        <hr class="literature-divider">

        <!-- /////// -->
        <!-- WEBFORM -->
        <!-- /////// -->


        <div class="literature-webform">
          <div class="left">
            <div class="form-title">
              Place Your Request
            </div>
          </div>
          <div class="right">
            <slot></slot>
          </div>
        </div>
      </div>

    </transition>

  </div>
</template>

<script>
  // import Vue from 'vue';
  import axios from 'axios';

  import EventBus from './LiteratureEventBus';
  import LiteratureCart from "./LiteratureCart";

  import {
    EVENT_LITERATURE_CART_FOCUS_ITEM,
    EVENT_LITERATURE_CART_REMOVE_ITEM,
    EVENT_LITERATURE_CART_UPDATE_ITEMS,
    EVENT_LITERATURE_PLACE_REQUEST
  } from "../constants";


  export default {
    name: "Literature",
    components: {
      'literature-cart': LiteratureCart
    },
    data() {
      return {
        loaded: true,
        viewFinalized: false,
        items: {},
        ids: [],
        focusedAt: '',
        animated: false,

        cart: {
          ids: [],
          quantity: {
          },
        },
      };
    },

    computed: {
      itemsInCart() {
        return this.cart.ids.map((id) => ({
          id: id,
          title: this.items[id].title,
          quantity: this.cart.quantity[id] || ''
        }))
      },
    },
    watch: {
      itemsInCart(newItems, oldItems) {
        EventBus.$emit(EVENT_LITERATURE_CART_UPDATE_ITEMS, newItems);
      }
    },
    methods: {
      // async getToken() {
      //   if (!this._token)
      //     this._token = await axios.get('/session/token');
      //
      //   return this._token;
      // },
      removeItemFromCart: function (id) {
        // const idx = this.cart.findIndex((item) => (item.id === id) )
        const idx = this.cart.ids.indexOf(id);
        (idx >= 0) && this.cart.ids.splice(idx, 1);
      },

      getExtension: function (filename) {
        return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
      },

      toggleItemFromCart(id) {
        const idx = this.cart.ids.indexOf(id);
        idx === -1 ? this.cart.ids.push(id) : this.cart.ids.splice(idx, 1);
      },

      placeRequest: function () {
        // const token = await this.getToken();
        EventBus.$emit(EVENT_LITERATURE_PLACE_REQUEST, true);
      },

      toSelection: function () {
        EventBus.$emit(EVENT_LITERATURE_PLACE_REQUEST, false);
      },

      onPlaceRequest: function () {
        this.viewFinalized = true;

        if (!!this.itemsInCart.length) {
          const requestItemValue = this.itemsInCart.reduce((acc, item) => {
            const qty = this.cart.quantity[item.id] || '';
            return (acc ? ', ' : ' ') + acc + item.title + (qty ? ` [${qty}]` : '');
          }, '');

          if (!!requestItemValue) {
            document.querySelector('input[name=requested_items]').value = requestItemValue;
          }
        }
      },
    },

    created() {
      this._token = '';
      this.loaded = false;

      axios.get('/jsonapi/node/literature?include=field_literature_image,field_literature_downloads.field_media_file&filter[status][value]=1&sort=field_literature_weight')
        .then(({ data }) =>
        {

          let media = {};
          let files = {};
          let ids = [];
          let itemSelected = {};

          const MAPPED_DATA = {
            'file--file'      :  files,
            'media--document' :  media,
          }

          data.included.forEach((item) => {
            MAPPED_DATA[item.type][item.id] = item;
          });
          // this.$set(this, 'media', media);
          // this.$set(this, 'files', files);

          const items = data.data.reduce((acc, item) => {
            ids.push(item.id);

            const img = item.relationships['field_literature_image']?.data;

            acc[item.id] = {
              id: item.id,
              type: item.type,
              title: item.attributes.title,
              body: item.attributes.body ? item.attributes.body.processed : '',
              inventory: item.attributes['field_literature_inventory'] ?? [],
              downloads: item.relationships['field_literature_downloads'].data.map((rel) => {
                if (!media[rel.id]) return {};
                return {
                  name: media[rel.id].attributes.name,
                  url: files[media[rel.id].relationships.field_media_file.data.id].attributes.uri.url,
                };
              }),
              image: {
                meta: img ? img.meta : null,
                url: img ? files[img.id].attributes.uri.url : null,
                shadow: item.attributes['field_style_drop_shadow'] || false
              }
            };

            itemSelected[item.id] = "";

            return acc;
          }, {});

          if (ids) {
            this.$set(this, 'items', items);
            this.$set(this, 'ids', ids);
            this.$set(this.cart, 'quantity', itemSelected);
          }
        }
      ).catch((e) => {
        console.warn(e);
      })
      .finally((e) => {
        this.loaded = true;
      });

    },
    mounted() {
      EventBus.$on(EVENT_LITERATURE_PLACE_REQUEST, (payload) => {
        if (!!payload) {
          this.onPlaceRequest();
        } else {
          this.viewFinalized = false;
        }
      });

      EventBus.$on(EVENT_LITERATURE_CART_REMOVE_ITEM, (payload) => {
        this.removeItemFromCart(payload);
      });

      EventBus.$on(EVENT_LITERATURE_CART_FOCUS_ITEM, (payload) => {

        if (payload) {
          this.focusedAt = payload;
          this.animated = true;

          setTimeout(() => {
            this.animated = false;  // reset CSS animation
          }, 500);  // match with animation-duration
        }
      });
    }
  }
</script>
